<template>
  <div v-if="backdrop">
    <div
      class="modal fade"
      :class="modal.open ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      @click="$event.target.classList.contains('modal') ? close() : true"
    >
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{config.title == null ? '&nbsp;' : config.title}}</h5>
            <button type="button" class="close" @click="close()" v-html="ic('close')"/>
          </div>

          <form @submit.prevent="submit">
            <div class="modal-body">
              <div class="form-group">
                <label for="salesman" class="form-label">Pilih Salesman <span class="text-red h-6" style="font-size: smaller;"> *</span> </label>
                <selectize
                    id="salesman"
                    :disabled="loading || initData != null"
                    v-model="data.id_salesman"
                    data-placeholder="Pilih Salesman"
                    required @input="$refs.toko.focus()">
                  <option
                      :value="d.id"
                      v-for="(d, i) in salesman"
                      :key="i"> {{d.nama_salesman}} ({{d.tim}}) </option>
                </selectize>
              </div>

              <div class="form-group" v-if="initData == null">
                <label for="toko" class="form-label">Pilih Toko <span class="text-red h-6" style="font-size: smaller;"> *</span>  <span class="form-label-description" v-html="toko.data.length == 0 ? 'Tidak ada toko' :toko.data.length+' toko'"/> </label>
                <div class="input-group" v-if="toko.search">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Cari toko"
                      v-model="toko.keyword"
                      :readonly="toko.request"
                      required
                      @keypress="$event.keyCode == 13 ? $refs.search.click() : false" ref="toko">
                  <button class="btn btn-white" type="button" v-html="toko.request ? spin() : ic('search')" @click="getToko" :disabled="toko.request" ref="search"/>
                </div>

                <div class="form-group" v-else>
                  <div style="width: calc(100% - 65px); display: inline-block" ref="toko">
                    <selectize
                        v-model="data.id_toko"
                        data-placeholder="Piih toko"
                        @input="_getBarangByPenjualanToko">
                      <option
                          :value="row.id"
                          v-for="(row, i) in toko.data"
                          :key="i"> {{row.no_acc+' - '+row.nama_toko}} </option>
                    </selectize>
                  </div>
                  <div style="width: 50px; display: inline-block" class="ml-2">
                    <button class="btn btn-white" v-html="ic('keyboard')" @click="_searchToko"/>
                  </div>
                </div>
              </div>

              <div class="form-group" v-else>
                <label for="" class="form-label">Nama Toko </label>
                <input type="text" readonly v-model="nama_toko" class="form-control" placeholder="Inputkan nama toko">
              </div>

              <div class="form-group" v-if="initData == null">
                <label for="salesman" class="form-label">Pilih Barang <span class="text-red h-6" style="font-size: smaller;"> *</span> </label>
                <selectize
                    id="salesman"
                    :disabled="loading || initData != null"
                    v-model="data.detail_retur.id_barang"
                    data-placeholder="Pilih Barang"
                    required @input="_getInvoiceByTokoAndBarang">
                  <option
                      :value="data.id"
                      v-for="(data, index) in barang"
                      :key="index"> {{data.kode_barang}} - {{data.nama_barang}} </option>
                </selectize>
              </div>

              <div class="form-group" v-if="initData == null">
                <label for="salesman" class="form-label">Pilih Invoice <span class="text-red h-6" style="font-size: smaller;"> *</span> </label>
                <selectize
                    id="salesman"
                    :disabled="loading || initData != null"
                    v-model="data.no_invoice_penjualan"
                    data-placeholder="Pilih Invoice"
                    required>
                  <option
                      :value="data.no_invoice"
                      v-for="(data, index) in no_invoice"
                      :key="index"> 
                      {{data.no_invoice}} (qty_pcs : {{data.qty_pcs}})  - Rp. {{ribuan(data.subtotal.toFixed(0))}} 
                      
                    </option>
                </selectize>
              </div>

              <div class="form-group" v-if="initData != null">
                <label for="" class="form-label">Pilih Invoice</label>
                <input type="text" readonly v-model="data.no_invoice_penjualan" class="form-control" placeholder="Inputkan nama toko">
              </div>

              <div class="form-group">
                <label class="form-label">Tiper Retur Barang</label>
                <label class="form-check form-check-inline" v-for="(d, i) in ['baik','bs']" :key="i">
                  <input class="form-check-input" type="radio" name="tr" :value="d" v-model="data.tipe_barang" >
                  <span class="form-check-label" v-html="ucwords(d)"/>
                </label>
              </div>

              <div class="form-group">
                <label class="form-label" for="potongan">Potongan</label>
                <input id="potongan" type="number" class="form-control" v-model="data.potongan" required>
              </div>

              <div v-if="initData == null">
                <div class="form-group">
                  <label class="form-label">Tipe Retur Barang</label>
                  <label class="form-check form-check-inline" v-for="(d, i) in tipe_retur" :key="i">
                    <input class="form-check-input" ref="type_retur" type="radio" name="tipe_pembayaran" :value="d.value" v-model="data.detail_retur.kategori_bs">
                    <span class="form-check-label" v-html="d.text"/>
                  </label>
                </div>
                <div class="form-group">
                  <label for="tanggal_expired" class="form-label">Tanggal Expired <span class="text-red h-6" style="font-size: smaller;"> *</span> </label>
                  <input  id="tanggal_expired" ref="tanggal_expired" type="date" class="form-control" v-model="data.detail_retur.expired_date" required>
                </div>
                <div class="row">
                  <div class="col form-group">
                    <label for="dus" class="form-label">Banyak Dus </label>
                    <input id="dus" type="tel" class="form-control" placeholder="Banyak dus" required @keypress="numberOnly($event)" v-model="data.detail_retur.qty_dus" >
                  </div>

                  <div class="col form-group">
                    <label for="pcs" class="form-label">Banyak Pcs</label>
                    <input id="pcs" type="tel" class="form-control" placeholder="Banyak pcs" required @keypress="numberOnly($event)" v-model="data.detail_retur.qty_pcs" >
                  </div>
                  <p class="ml-1 h6">Kolom QTY harus diisi minimal salah satu di antara dus atau pcs, atau boleh diisi keduanya</p>
                </div>
              </div>
              

              <div class="form-group">
                <label for="keterangan" class="form-label">Keterangan Retur</label>
                <textarea
                    id="keterangan"
                    class="form-control"
                    v-model="data.keterangan"
                    placeholder="Keterangan"
                    ref="keterangan">
                </textarea>
              </div>

              <div>
                <p class="ml-1 h5 text-red">* Data harus diisi</p>
              </div>
            </div>

            <div class="modal-footer pt-2">
              <button type="button" class="btn btn-white" @click="close()" v-html="'Tutup'" />

              <button v-if="initData == null"
                type="submit"
                class="btn btn-primary"
                :disabled="isSubmit || (data.detail_retur.qty_dus == 0 && data.detail_retur.qty_pcs == 0)" @click="submit"
                v-html="isSubmit ? spin() : 'Simpan'"
              />
              <button v-else
                type="submit"
                class="btn btn-primary"
                :disabled="isSubmit" @click="submit"
                v-html="isSubmit ? spin() : 'Simpan'"
              />
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import {mapActions, mapState} from "vuex";

export default {
  name: "Form",
  props: {
    config: {
      default: {
        view: false,
        title: "Modal Title"
      }
    },
    initData: null,
    isSubmit: {default: false},
    dismiss: {default: true}
  },

  mixins: [helper],

  data() {
    return {
      backdrop: false,
      modal: {
        open: false,
        formNav: 0
      },

      toko: {
        keyword: '', request: false, search: true,
        data: [],
      },

      nama_toko: null, salesman: [], 
      no_invoice:[],
      tipe_retur: [],
      barang: [],

      data: {
        id_salesman: null,
        id_toko: null,
        tipe_barang: 'bs',
        keterangan: null,
        id_mitra: 1,
        potongan: 0,
        detail_retur :{
          id_barang:'',
          kategori_bs:'kd',
          expired_date:'',
          qty_dus:0,
          qty_pcs:0
        }
      },

    };
  },
  computed: {
    ...mapState(['loading']),
  },

  methods: {
    ...mapActions('salesman', ['getListSalesman','getListInvoiceBySales']),
    ...mapActions('barang', ['listBarangByPenjualanToko','listInvoiceByBaranngAndToko']),
    ...mapActions('option', ['getOptionsByCode']),

    close() {
      this.$emit("update:config", { view: false });
    },

    _getJenisReturBarang() {
      this.getOptionsByCode('jenis_retur_barang').then( res => {
        this.tipe_retur = res
      })
    },

    _getSalesman(){
      this.request = true

      this.axios.get('salesman').then(res => {
        this.salesman = res.data.data;
        this.request = false
      }).catch(err => {
        this.onError(err);
        this.request = false
      });
    },

    async _getInvoiceByTokoAndBarang(){
      try {
        this.no_invoice = await this.listInvoiceByBaranngAndToko({id_toko : this.data.id_toko ,id_barang : this.data.detail_retur.id_barang})
      } catch (error) {
        console.log(error)
      }
    },

    async _getBarangByPenjualanToko(){
      try {
        this.barang = await this.listBarangByPenjualanToko({id_toko : this.data.id_toko })
      } catch (error) {
        console.log(error)
      }
    },

    getToko(){
      if(this.toko.keyword.length < 2){
        this.$refs.toko.focus()
      }else{
        let sales = this.salesman.find(item => item.id == this.data.id_salesman)

        this.toko.request = true
        this.axios.get('toko?keyword='+this.toko.keyword+'&id_tim='+sales.id_tim).then(res => {
          this.$refs.toko.focus()

          if(res.data.data.length != 0){
            this.toko.search = false
          }

          this.toko.keyword = ''
          this.toko.request = false
          this.toko.data = res.data.data

          setTimeout(() => {
            if(res.data.data.length != 0){
              this.$refs.toko.getElementsByTagName('input')[0].focus()
            }
          }, 50);
        }).catch(err => {
          this.onError(err)
          this.toko.request = false
        })
      }
    },

    _searchToko(){
      this.toko.search = true

      setTimeout(() => {
        this.$refs.toko.focus()
      }, 50);
    },

    submit() {
      if(this.initData == null){
        if((this.data.detail_retur.qty_dus == 0 && this.data.detail_retur.qty_pcs == 0)){
          this.toast("qty_dus atau qty_pcs tidak boleh kosong. isi salah satu field");
          return
        }
      }
      this.$emit('update:isSubmit', true)
      this.$emit('submit', this.data);
    },

  },

  watch: {
    "config.view": function(view) {
      if (view) {
        this.$emit("update:isSubmit", false);

        this.backdrop = true;

        setTimeout(() => {
          this.modal.open = view;
          if (this.tipe_retur.length === 0) this._getJenisReturBarang()
          if(this.salesman.length == 0){
            this._getSalesman()
          }
        }, 100);
      } else {
        this.modal.open = view;

        setTimeout(() => {
          this.backdrop = view;
        }, 100);
      }
    },

    initData: function(data) {
      if(data == null){
        Object.assign(this.$data.data, this.$options.data.call(this).data);
        this.nama_toko = null
      }else{
        this.nama_toko = data.nama_toko
        this.data.sales_retur_date = data.sales_retur_date;

        for (const key in this.data) {
          this.data[key] = data[key]
        }
      }
    },

  }
};
</script>
